// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"530":"d88bbfe5","599":"32b8bbdf","926":"d88bbfe5"}[chunkId] + ".chunk.css";
};